var exports = {
  "z": "x1cb7f6e3--29e158--root",
};

module.exports = exports;
